import { gql } from 'graphql-request'

export const createSearchCategoriesQuery = () => gql`
  {
    Collections(limit: 100) {
      docs {
        id
        name
      }
    }

    Categories(limit: 100) {
      docs {
        id
        name
      }
    }

    MemberTiers(sort: "planLevel") {
      docs {
        id
        name
        slug
        planLevel
      }
    }
  }
`

type SearchCategory = {
  id: string
  name: string
  planLevel?: number
}

export const mapToSearchCategories = (
  data: any
): Record<string, SearchCategory[]> => {
  return {
    collections: data.Collections.docs,
    categories: data.Categories.docs,
    memberTiers: data.MemberTiers.docs,
  }
}
